const caretDropSVG = `

<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.0.0, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" width="11.67px"
	 height="24.991px" viewBox="0 0 11.67 24.991" enable-background="new 0 0 11.67 24.991" xml:space="preserve">
<g id="Layer_1">
	
		<polyline fill="none" stroke="#8021fc" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" points="
		10.17,1.5 1.5,11.917 9.012,23.491 	"/>
</g>
<g id="LiveTXT" display="none">
</g>
<g id="GRids">
</g>
</svg>

`;


export default caretDropSVG;



// WEBPACK FOOTER //
// ./src/Components/inlineSVGs/caretDropSVG.js